// extracted by mini-css-extract-plugin
export var discard = "_34-3";
export var muiTooltipTooltip = "_34-5";
export var notificationBar = "_34-2";
export var saveButtonHoverSlotWrapper = "_34-4";
export var show = "_34-1";
export var spacer = "_34-0";